export default __webpack_public_path__ + "50182020c1d8948d44cd67c70030cc11.jpg";